import { Instance, SnapshotOut, types } from 'mobx-state-tree';

/**
 * # Mngr
 *
 * Mngr을 설명하세요.
 */
export const Mngr = types
  .model('Mngr')
  // --------------------------------------------------------------------------
  .props({
    mngrSid: types.identifierNumber,
    gubn: types.maybeNull(types.string), // 구분
    mngrInfo: types.maybeNull(types.string), // 직책/이름
    mngrEmail: types.maybeNull(types.string), // E-mail
    mngrTel: types.maybeNull(types.string), // 전화

    useYn: types.optional(types.string, 'Y'),
    delYn: types.optional(types.string, 'N'),

    insertDt: types.optional(types.number, 0),
    updateDt: types.optional(types.number, 0),
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model mngr --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: IMngr }) => {
      const newProps = { ...self, ...props } as IMngr;
      (Object.keys(newProps) as TMngrKeys[]).forEach((key) => {
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TMngr = Instance<typeof Mngr>;
type TMngrSnapshot = SnapshotOut<typeof Mngr>;

export interface IMngr extends TMngr {}
export type TMngrKeys = keyof TMngrSnapshot & string;
export interface IMngrSnapshot extends TMngrSnapshot {}
export const createMngr = () => types.optional(Mngr, {} as TMngr);
